// extracted by mini-css-extract-plugin
export var modal = "_4p-0";